module.exports = __webpack_public_path__ + "2b77a48b.png";